export default {
  Title: 'Tham số báo cáo',
  Year: 'Năm',
  ViewReport: 'Xem báo cáo',
  ChoosePeriod: 'Chọn kỳ báo cáo',
  FromDate: 'Từ ngày',
  ToDate: 'Đến ngày',
  IsPrintAdjustMonth: 'In tháng chỉnh lý quyết toán',
  Department: 'Phòng ban',
  Inventory: 'Loại vật tư/ CCDC',
  ConfirmViewReport: 'Xem báo cáo',
};
